import { Component, OnInit,Optional } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UmsService } from '../ums.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { Router } from '@angular/router';
import { PaymentReceiptComponent } from '../payment-receipt/payment-receipt.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-exam-form-report',
  templateUrl: './exam-form-report.component.html',
  styleUrls: ['./exam-form-report.component.scss']
})
export class ExamFormReportComponent implements OnInit {
  examformreport: FormGroup;
  examscheduleList: any[];
  filteredListExamSch: any[];
  SessionNo: any;
  table
  allClgCountdatalist: any;
  count: any;
  collegedataList: any[];
  filteredListCollege: any[];
  userPermission: any;
  utp: any;
  UserCollege: any;
  Branch: boolean;
  BranchList: any[];
  filteredListBranch: any[];
  maxSubjectsPerStudent: number = 0;
   sessionList: any[];
  SessionFilterList: any[];
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  examList
  filteredListExam
  isAdminView = false; 
  statusList = [
  { label: 'Approved', value: 'Y' },
  { label: 'Rejected', value: 'N' },
  { label: 'Pending', value: 'P' } 
];
selectedStatus = '';
filteredAdminData: any[] = []; 
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private modalPopupService: ModalpopService,
    private dialog: MatDialog,
  @Optional() public dialogRef?: MatDialogRef<ExamFormReportComponent>) { }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
  this.isAdminView = this.userPermission[0].CgUi === 'U';

  if (!this.isAdminView) {
    this.UserCollege = this.userPermission[0].CgId;
  } else {
    this.UserCollege = '';
  }
    this.utp = sessionStorage.getItem('usertypeee');
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      this.fetchSecretData();
    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
     // this.getCourseWiseExam(item.CoCode);
    }
    this.table = false;
    this.examformreport = this.fb.group({
      college: [''],
      course: [''],
      EmId: ['', Validators.required],
      Branch: [0]
    });
    this.fetchSession();
    this.getClg();
  }
fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo'];
      //this.getCourseWiseExam(item.CoCode)
    }
    );
  }

  getdata() {
    if (this.examformreport.invalid) {
      this.examformreport.get('EmId').markAsTouched();
    }
    else {
      this.getClgCountData();
    }
  }

  getClgCountData() {
    const payload = {};
    this.spinner.show();
    payload['EmId'] = this.examformreport.value.EmId;
    payload['CgCode'] = this.examformreport.value.college || this.UserCollege;
    payload['Branch'] = this.examformreport.value.Branch ? this.examformreport.value.Branch : 0;
    this.umsService.fetchCollegeCount(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.table = true;
        this.allClgCountdatalist = res.data
        this.allClgCountdatalist.forEach(item => {
  const statusArray = item.ApprovalStatus? item.ApprovalStatus.split(',').map(s => s.trim()): [];
  item.isLocked = statusArray.length > 0 && statusArray.every(s => s === 'Y' || s === 'N');
});
        this.count = res.data.length
     if (this.isAdminView && this.selectedStatus) {
        this.filterByStatus();
      } else {
        this.filteredAdminData = [];
      }
      }
      else {
        this.spinner.hide();
        this.table = false;
        let data = {};
        data['message'] = "No Data Found";
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }

    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.table = false;
      let data = {};
      data['message'] = "No Data Found";
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    })
  }

  calculateMaxSubjects(data: any[]): number {
    let maxSubjects = 0;
    data.forEach(item => {
      if (item.SubjectsPerStudent) {
        const subjectsPerStudent = this.formatSubjectsPerStudent(item.SubjectsPerStudent);
        subjectsPerStudent.forEach(studentSubjects => {
          if (studentSubjects.length > maxSubjects) {
            maxSubjects = studentSubjects.length;
          }
        });
      }
    });
    return maxSubjects;
  }

  getArrayField(fieldString: string, index: number): string {
    if (!fieldString) return '';
    const array = fieldString.split(',').map(s => s.trim());
    return array[index] || '';
  }

  fetchSession() {
  this.spinner.show();
  this.umsService.getSession({}).subscribe(res => {
    this.spinner.hide();
    if (res.status) {
      this.sessionList = res.data.filter(x => x.SnStatus === 'O');
      this.SessionFilterList = [...this.sessionList];
    }
  });
}

 getCourse(CgCode) {
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = CgCode;
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
      this.CourseList = res.data;              
      this.filteredListCourse = res.data.slice();
    } else {
      this.CourseList = [];
      this.filteredListCourse = [];
    }
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

getCourseWiseExam(CoCode) {
  this.spinner.show();
  //this.examscheduleList = [];
  //this.filteredListExamSch = [];
  const payload = {
    EmCoCode: CoCode
  };
  this.umsService.getExam(payload).subscribe(res => {
    this.spinner.hide();
    if (res.status) {
      this.filteredListExamSch = res.data.slice();
      this.examformreport.get('EmId')?.reset();
    } else {
      this.examscheduleList = [];
      this.filteredListExamSch = [];
    }
  });
}

getCollege(item) {
  this.spinner.show();
  const payload = { CoCode: this.UserCollege };
  this.umsService.getCollege(payload).subscribe(res => {
    this.spinner.hide();
    if (res.status) {
      this.collegedataList = res.data;
      this.filteredListCollege = this.collegedataList.slice();
    }else {
      this.collegedataList = [];
      this.filteredListCollege = [];
    }
  });
}

download(event: Event) {
    event.preventDefault();
    const payload: any = {
      EmId: this.examformreport.value.EmId,
      CgCode: this.examformreport.value.CgCode || this.UserCollege,
      Branch: this.examformreport.value.Branch ? this.examformreport.value.Branch : 0
    };

    this.umsService.fetchCollegeCount(payload).subscribe((res) => {
      if (res.status) {
        this.maxSubjectsPerStudent = this.calculateMaxSubjects(res.data);
        
        const finalData: any[] = [];

        res.data.forEach((element: any) => {
          const students = this.formatStudents(element.StudentsName);
          const subjectsPerStudent = this.formatSubjectsPerStudent(element.SubjectsPerStudent);
          const mothersNames = this.formatStudents(element.StudentsMothName);
          const mobiles = this.formatStudents(element.StuMobile);
          const emails = this.formatStudents(element.StuEmailId);
          const genders = this.formatStudents(element.StuGender);
          const castes = this.formatStudents(element.StuCaste);
          const enrollments = this.formatStudents(element.RegistrationNumber);
          const midNames = this.formatStudents(element.StudentsMidName);
          const statusArray = element.ApprovalStatus
         ? element.ApprovalStatus.split(',').map(s => s.trim())
        : [];
          students.forEach((student: string, index: number) => {
            const subjects = subjectsPerStudent[index] || [];
            const rawStatus = statusArray[index] || '';
            const statusText =
            rawStatus === 'Y' ? 'Approved' :
            rawStatus === 'N' ? 'Rejected' : 'Pending';
                const row: any = {};
                row['Study Center Code'] = element.StudyCenterCode;
                row['Study Center Name'] = element.StudyCenterName;
                row['College Code'] = element.CgCode;
                row['College Name'] = element.CollegeName;
                row['Total Students'] = element.TotalStudents;
                row['Students First Name'] = student;
                row['Father Name'] = midNames[index] || '';
                row['Mother Name'] = mothersNames[index] || '';
                row['Mobile No'] = mobiles[index] || '';
                row['Email Id'] = emails[index] || '';
                row['Gender'] = genders[index] || '';
                row['Caste'] = castes[index] || '';
                row['Enrollment No'] = enrollments[index] || '';
                row['Course'] = element.Course;
                row['Branch'] = element.Branch || '';
            for (let i = 0; i < this.maxSubjectsPerStudent; i++) {
              const subjectKey = `Subject_${i + 1}`;
              if (subjects[i]) {
                row[subjectKey] = `${subjects[i].SubCode} - ${subjects[i].Sub}`;
              } else {
                row[subjectKey] = '';
              }
            }
            row['Status'] = statusText;
            finalData.push(row);
          });
        });
        const csvContent = this.convertArrayToCSV(finalData);
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        link.download = `college-students-subjects-${timestamp}.csv`;
        
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  }

  convertArrayToCSV(array: any[]): string {
    if (array.length === 0) return '';
    
    const header = Object.keys(array[0]);
    const csvRows = [];
    csvRows.push(header.join(','));
    
    for (const row of array) {
      const values = header.map(header => {
        const escaped = ('' + row[header]).replace(/"/g, '""');
        return `"${escaped}"`;
      });
      csvRows.push(values.join(','));
    }
    
    return csvRows.join('\n');
  }

  back() {
    this.examformreport.reset();
    this.table = false;
    this.maxSubjectsPerStudent = 0;
  }

  formatStudents(studentString: string): string[] {
    if (!studentString) return [];
    return studentString.split(',').map(s => s.trim());
  }

  formatEnrollmentNumbers(enrollString: string): string[] {
    return enrollString?.split(',').map(s => s.trim()) || [];
  }
  getSubjectsForStudent(subjectsString: string, studentIndex: number): any[] {
    const subjectsPerStudent = this.formatSubjectsPerStudent(subjectsString);
    return subjectsPerStudent[studentIndex] || [];
  }

  formatSubjectsPerStudent(subjectsString: string): { SubCode: string; Sub: string }[][] {
    if (!subjectsString) return [[]];
    const studentSubjectsArray = subjectsString.split('|');
    
    return studentSubjectsArray.map(subjectStr => {
      if (!subjectStr.trim()) return [];
      const subjects = subjectStr.trim().split(',');
      
      return subjects.map(s => {
        if (!s.trim()) return { SubCode: '', Sub: '' };
        const parts = s.trim().split(';');
        let subCode = parts[0] || '';
        let subName = parts[1] || '';
        return {
          SubCode: subCode.trim(),
          Sub: subName.trim()
        };
      });
    });
  }

  getClg() {
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
    this.filteredListExam = [];
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.UserCollege
    this.umsService.getCollege(payload).subscribe(res => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.collegeList = [];
    })
  }

  fetchBranch(id) {
    const payload = {};
    payload['EmId'] = id;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.Branch = true;
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
      else{
        this.Branch = false;
        this.BranchList = [];
        this.examformreport.controls['Branch'].setValue(0);
      }
    });
  }


approveForm(item: any, index: number) {
  const rgId = this.getArrayField(item.RgId, index);
  if (!rgId) {
    return;
  }
  const payload = {
    RgId: Number(rgId),
    ApprovalStatus: 'Y'
  };
  this.spinner.show();
  this.umsService.approveRejectExamForm(payload).subscribe(
    res => {
      this.spinner.hide();
      if (res.message === 'ExamFormByExam Updated') {
  item.isLocked = true;
}
   let arr = item.ApprovalStatus ? item.ApprovalStatus.split(',') : [];
arr[index] = 'Y';
item.ApprovalStatus = arr.join(',');
      this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent,
        {
          title: 'Information',
          icon: 'fas fa-check',
          message: `Exam form approved successfully`
        }
      );
    },
    () => this.spinner.hide()
  );
}


rejectForm(item: any, index: number) {
   const rgId = this.getArrayField(item.RgId, index);
  const payload = {
    RgId: Number(rgId),
    ApprovalStatus: 'N'
  };
  this.spinner.show();
  this.umsService.approveRejectExamForm(payload).subscribe(
    res => {
      this.spinner.hide();
if (res.message === 'ExamFormByExam Updated') {
  item.isLocked = true;

}
  let arr = item.ApprovalStatus ? item.ApprovalStatus.split(',') : [];
arr[index] = 'N';
item.ApprovalStatus = arr.join(',');
      this.modalPopupService.openPopup<AlertBoxComponent>(
      AlertBoxComponent,
      {
        title: 'Information',
        icon: 'fas fa-times',
        message: `Exam form Rejected`
      }
)

},
    () => this.spinner.hide()
  );
}

filterByStatus() {
  if (!this.selectedStatus || !this.allClgCountdatalist?.length) return;
  this.filteredAdminData = [];
  const selectedCollege = this.examformreport.value.college;
  this.allClgCountdatalist.filter(item => {
    return !selectedCollege || item.CgCode == selectedCollege;
  }).forEach(item => {
    const names = this.formatStudents(item.StudentsName);
    const mobiles = this.formatStudents(item.StuMobile);
    const statuses = this.formatStudents(item.ApprovalStatus);

    names.forEach((name, i) => {
      const rawStatus = statuses[i];
      const status = rawStatus === 'Y' || rawStatus === 'N' ? rawStatus : null;

      if (
        (this.selectedStatus === 'Y' && status === 'Y') ||
        (this.selectedStatus === 'N' && status === 'N') ||
        (this.selectedStatus === 'P' && status === null)
      ) {
        this.addAdminRow(
          name,
          mobiles[i],
          status,
          item.CollegeName,
          item.Course,
          this.getArrayField(item.RegistrationNumber, i)
        );
      }
    });
  });
}


addAdminRow(name: string, mobile: string, status: string | null,college: string,
  course: string,
  registrationNo: string) {
  this.filteredAdminData.push({
    studentName: name,
    mobile: mobile || '',
    college: college,
    course: course,
    registrationNo: registrationNo,
    status: status
  });
}
onCourseChange(coCode: number) {
  this.examformreport.get('EmId')?.reset();
  this.filteredListExamSch = [];
  this.getCourseWiseExam(coCode);
}

}
